import React, { useEffect } from 'react';
import { socket } from '../../socket';
import { connect } from 'react-redux';

const ActiveCollabTile = (props) => {

  useEffect(() => { 
    socket.emit('onAddActiveCollaboratorServer',{ "journeyId": props.journeyId, "email": props.username } );
  }, []);

  return <div></div>;
};

const mapStateToProps = (state) => ({
  journeyId: state.app.journeyId,
  username: state.app.username,
});

export default connect(mapStateToProps)(ActiveCollabTile);
